import site from './site.config.js';
let csrfToken = '';
async function request(path, {method='GET', body, idempotencyKey, signal, csrfRetried=false}={}) {
  if(method!=='GET'&&!csrfToken) await getSession();
  const response=await fetch(`${site.apiBase}/nail/${path}`, {
    method, credentials:'same-origin', signal,
    headers:{Accept:'application/json', ...(body!==undefined?{'Content-Type':'application/json'}:{}), ...(method!=='GET'?{'X-CSRFToken':csrfToken}:{}), ...(idempotencyKey?{'Idempotency-Key':idempotencyKey}:{})},
    ...(body!==undefined?{body:JSON.stringify(body)}:{}),
  });
  const data=await response.json().catch(()=>({}));
  if(response.status===403&&data.code==='csrf_failed'&&!csrfRetried){csrfToken='';await getSession();return request(path,{method,body,idempotencyKey,signal,csrfRetried:true});}
  if(!response.ok){const error=new Error(data.error||data.detail||(response.status===503?'商城服务暂时不可用，请稍后重试':'暂时无法完成，请检查填写内容后重试'));error.status=response.status;error.code=data.code;error.fields=data.fields||data.errors;throw error;}
  if(data.csrfToken)csrfToken=data.csrfToken;
  return data;
}
export const getSession=()=>request('session/');
export const registerAccount=form=>request('auth/register/',{method:'POST',body:form});
export const loginAccount=form=>request('auth/login/',{method:'POST',body:form});
export const logoutAccount=()=>request('auth/logout/',{method:'POST',body:{}}).then(data=>{csrfToken='';return data;});
export const getStoreConfiguration=()=>request('config/');
export const getStoreCatalog=signal=>request('catalog/',{signal});
export const quoteCart=(items,signal)=>request('quote/',{method:'POST',body:{items},signal});
export const submitOrderDraft=(body,idempotencyKey)=>request('orders/',{method:'POST',body,idempotencyKey});
export const getOrders=()=>request('orders/');
export const getOrder=number=>request(`orders/${encodeURIComponent(number)}/`);
export const startOrderPayment=(number,quoteId,provider)=>request(`orders/${encodeURIComponent(number)}/checkout/`,{method:'POST',body:{quoteId,provider,accepted:true}});
export const confirmOrderPayment=number=>request(`orders/${encodeURIComponent(number)}/payment/confirm/`,{method:'POST',body:{}});
export const submitContact=form=>request('contact/',{method:'POST',body:form});

export const getPricing=()=>request('pricing/'+(new URLSearchParams(location.search).get('cms_preview')==='1'?'?preview=1':''));

export async function submitDesignRequest(form,csrfRetried=false){
 if(!csrfToken)await getSession();
 const response=await fetch(`${site.apiBase}/nail/design-requests/`,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-CSRFToken':csrfToken},body:form});
 const data=await response.json().catch(()=>({}));
 if(response.status===403&&data.code==='csrf_failed'&&!csrfRetried){csrfToken='';await getSession();return submitDesignRequest(form,true)}
 if(!response.ok)throw Error(data.error||data.detail||'需求提交失败，请检查图片与填写内容后重试');
 return data;
}

export const getContactMessages=()=>request('contact/');
